module.exports = __webpack_public_path__ + "static/media/bg-login.af70d079.jpg";